import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets window scroll to the top on every route change.
// Mount once, inside <BrowserRouter>.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use "instant" (not smooth) to avoid a visible scroll-up animation
    // which can be jarring on navigation.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
